import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ReactiveFormsModule} from "@angular/forms";
import {ErrorModule} from "../errors/error.module";
import {CronAdminComponent} from "./cron-admin.component";
import {CronAdminService} from "./cron-admin.service";

@NgModule({
  providers: [
    CronAdminService,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    ErrorModule,
  ],
  declarations: [
    CronAdminComponent,
  ],
  entryComponents: [
    CronAdminComponent,
  ],
  exports: [
  ],
})
export class CronAdminModule {
}
